import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ENVIRONMENT } from '@environment';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowLeft,
  faArrowRight,
  faCircleInfo,
  faMaximize,
  faMinimize,
} from '@fortawesome/free-solid-svg-icons';
import { CoreModule } from '@noovle/core';
import { LoadingComponent } from '@noovle/ui-libraries';
import { NavBarComponent } from '@noovle/ui-nav-bar';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  providers: [
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    { provide: ENVIRONMENT, useValue: environment },
  ],
  bootstrap: [AppComponent],
  imports: [
    CoreModule,
    LoadingComponent,
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    NavBarComponent,
    BrowserAnimationsModule,
    FontAwesomeModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxSliderModule,
  ],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faCircleQuestion,
      faCircleInfo,
      faMaximize,
      faMinimize,
      faArrowLeft,
      faArrowRight
    );
  }
}
